module.exports = __webpack_public_path__ + "media/reskin-images/icon--unlocked-90ab1057.svg";